
import React, { useEffect, useState } from 'react'
import axios from 'axios'
import Select from 'react-select'
import Entry from './components/Entry'
import InfiniteScroll from 'react-infinite-scroll-component';
import camelcaseKeys from 'camelcase-keys';
import qs from 'qs'
import _ from 'lodash'
import ShortContactForm from '@components/contact/short_contact_form'

const GlossaryEntries = ({ entries, categories, keywords, indexPath }) => {
  const [localEntries, setLocalEntries] = useState(entries)
  const [hasMore, setHasMore] = useState(true);
  const [page, setPage] = useState(2);
  const [filters, setFilters] = useState({});
  const [currentKeywords, setCurrentKeywords] = useState(keywords);

  const generateRange = ([start, end]) => _.range(start.charCodeAt(0), end.charCodeAt(0) + 1).map(i => String.fromCharCode(i));

  let queryString = qs.stringify(
    {
      q: {
        id_in: filters.keywordIds,
        glossary_category_id_in: filters.categoryIds,
        name_start_any: filters.nameStart?.length > 0 ? generateRange(filters.nameStart) : undefined
      }
    },
    { arrayFormat: 'brackets' }
  )

  const setCategory = (categories) => {
    let c = categories.map(({ value }) => value)
    setFilters((prevState) => ({ ...prevState, categoryIds: c }))

    queryString = qs.stringify(
      {
        q: {
          glossary_category_id_in: c,
        }
      },
      { arrayFormat: 'brackets' }
    )

    setCurrentKeywords(keywords.filter((k) => c.includes(k.glossaryCategoryId)));
    fetchData(1)
  }

  const fetchData = (paginationPage = page) => {
    axios
      .get(
        indexPath + `?${queryString}&page=${paginationPage}`,
        { headers: { Accept: 'application/json', 'Content-Type': 'application/json' } })
      .then((res) => {
        const data = camelcaseKeys(res.data, { deep: true })
        const entries = paginationPage === 1 ? data.glossaryEntries : [...localEntries, ...data.glossaryEntries]
        setLocalEntries(entries);
        setHasMore(data.glossaryEntries.length >= 5)
      })

    setPage(paginationPage + 1);
  };

  const filterCollectionWithRange = (range) => setFilters((prevState) => ({ ...prevState, nameStart: range }))

  useEffect(() => {
    if (filters.nameStart !== undefined) fetchData(1)
  }, [filters.nameStart])

  const customStyles = {
    control: base => ({
      ...base,
      minHeight: 43,
      border: '1px solid #CCCCCC',
      borderRadius: 0
    }),
    valueContainer: base => ({
      ...base,
      padding: '0px 16px'
    }),
    indicatorsContainer: base => ({
      ...base,
      padding: '0px 16px'
    }),
    placeholder: base => ({
      ...base,
      color: '#6D757F',
    }),
    menu: base => ({
      ...base,
      border: '1px solid #CCCCCC',
      borderRadius: 0
    })
  };

  const TopFilters = () => {
    return <div className='top-filters'>
      <a className={`filter-link ${filters.nameStart == undefined ? 'active' : ''}`} onClick={() => filterCollectionWithRange(null)}>All</a>
      {['AE', 'FJ', 'KO', 'PT', 'UZ'].map((range) => (
        <a className={`filter-link ${filters.nameStart === range ? 'active' : ''}`} onClick={() => filterCollectionWithRange(range)}>{range.split('').join('-')}</a>
      ))}
    </div>
  }

  const categoryOptions = categories.map(({ id, name }) => ({ value: id, label: name }))
  const keywordOptions = currentKeywords.map(({ id, name }) => ({ value: id, label: name }))

  const getWidth = () => window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
  const isMobile = getWidth() <= 992;

  return <div>
    <TopFilters />

    <div className='grid-wrapper'>
      <InfiniteScroll
        dataLength={localEntries.length}
        next={fetchData}
        hasMore={hasMore}
        className='entries'
      >
        <div>
          {localEntries.map((entry, i) => (
            <React.Fragment key={entry.name}>
              {isMobile && i !== 0 && i % 2 === 0 && (
                <div className='marketing-text mobile'>
                  <p>
                    Get in touch with us and start the process of creating a digital solution to support your business.
                  </p>
                  <a className='btn menu-link gradient gradient-light' href='/contact' rel='canonical'>Contact us</a>
                </div>
              )}
              <Entry {...entry} />
            </React.Fragment>
          ))}
        </div>
      </InfiniteScroll>

      <div className='filters'>
        <div>
          <div className='form'>
            <div className='form-select'>
              <Select
                isMulti
                placeholder='Select category'
                options={categoryOptions}
                components={{ IndicatorSeparator: () => null }}
                value={categoryOptions.filter(({ value }) => (filters.categoryIds || []).includes(value))}
                onChange={setCategory}
                styles={customStyles}
              />
            </div>

            <div className='row margin-top-2 with-button'>
              <div className='keywords-select-wrapper form-select'>
                <Select
                  isMulti
                  placeholder='Search for keywords...'
                  options={keywordOptions}
                  components={{ IndicatorSeparator: () => null }}
                  value={keywordOptions.filter(({ value }) => (filters.keywordIds || []).includes(value))}
                  onChange={(values) => setFilters((prevState) => ({ ...prevState, keywordIds: values.map(({ value }) => value) }))}
                  styles={customStyles}
                />
              </div>
              <button className='submit-btn' onClick={() => fetchData(1)}>Search</button>
            </div>
          </div>

          {!isMobile && (
            <div className='contact-wrapper'>
              <form id="contact-form" action="/contact/submit" acceptCharset="UTF-8" method="post">
                <ShortContactForm />
              </form>
            </div>
          )}
        </div>
      </div>
    </div>
  </div>
}

export default GlossaryEntries